import React, { FunctionComponent } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';

import { useToggler } from '../../../../../utils/toggler.utils';
import { TaskWidget } from '../../widget-items/task-widget-items/TaskWidget';
import { TaskCard } from '../TaskCard';
import { ITasksListProps } from './types';
import { taskSimpleSelectors } from '../../../../../app/resource/task-simple/task-simple.selectors';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { meetingSimpleSelectors } from '../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { userSelectors } from '../../../../../app/resource/user/user.selectors';
import { Tooltip } from '../../../../common/Tooltip';
import { isMemberPartOfMeeting } from '../../../../../utils/user.utils';
import { sortDoneTasksByCompletedOrChangedAt } from '../../../../../utils/task.utils';

export const WidgetTasksList: FunctionComponent<ITasksListProps> = ({
  activeIds,
  doneIds,
  type,
  isAdmin,
  meetingId,
  userId,
}) => {
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId);
  const user = useSelectWithParams(userSelectors.selectResourceById, userId);

  const [show, handleShow] = useToggler(false);

  const activeTasks = useSelectWithParams(taskSimpleSelectors.selectResourcesById, activeIds);
  const doneTasks = useSelectWithParams(taskSimpleSelectors.selectResourcesById, doneIds);
  const sortedDoneTasks = sortDoneTasksByCompletedOrChangedAt(doneTasks);
  const title = `${user?.firstName} ${user?.lastName}`;

  let memberRemovedFromMeeting = false;
  let memberDeletedFromTenant = false;

  if (user && meeting) {
    memberRemovedFromMeeting = !isMemberPartOfMeeting(user, meeting);
    memberDeletedFromTenant = !!user.deleted;
  }

  const memberDeleted = memberRemovedFromMeeting || memberDeletedFromTenant;

  return (
    <div className="single-card-container">
      <div className="panel-body p-0">
        <div
          className="border-radius-1 p-2 pb-1"
          style={isAdmin ? { backgroundColor: '#f6f9fb' } : { backgroundColor: '#eff1f3' }}
        >
          {!!title && (
            <div className="panel-header p-0">
              <h2 className={`bold ${memberDeleted ? 'deleted-user-title' : ''}`}>{title}</h2>
              {memberDeleted && (
                <Tooltip
                  content={
                    memberDeletedFromTenant
                      ? 'User has been removed from this workspace'
                      : 'User is no longer part of this meeting'
                  }
                  direction="bottom"
                  bgColor="#13ac92"
                  textColor="white"
                >
                  <i className="icon-info"></i>
                </Tooltip>
              )}

              <div className="ml-auto flex"></div>
            </div>
          )}
          <div className="todo-container tabs">
            <Droppable droppableId={`active`} isDropDisabled={true}>
              {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {activeTasks.map(
                    (task, index) =>
                      task && (
                        <Draggable key={`active-${task.id}`} draggableId={task.id} index={index} isDragDisabled={true}>
                          {(provided) => {
                            if (type === 'qi') {
                              return <TaskWidget task={task} provided={provided} meetingId={meetingId} />;
                            }
                            return <TaskCard task={task} provided={provided} meetingId={meetingId} />;
                          }}
                        </Draggable>
                      ),
                  )}
                  {!activeIds.length && <div style={{ height: '20px' }}></div>}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>

            <div className="hidden_cards_container">
              <span className="card-separator hide-cards" onClick={handleShow}>
                <span className="completed_text">
                  {show ? `HIDE COMPLETED (${doneIds.length})` : `SHOW COMPLETED (${doneIds.length})`}
                </span>
              </span>
              {show && (
                <Droppable droppableId={'done'} isDropDisabled={true}>
                  {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      {sortedDoneTasks.map(
                        (task, index) =>
                          task && (
                            <Draggable
                              key={`done-${task.id}`}
                              draggableId={task.id}
                              index={index}
                              isDragDisabled={true}
                            >
                              {(provided) => {
                                if (type === 'qi') {
                                  return <TaskWidget task={task} provided={provided} meetingId={meetingId} />;
                                }
                                return <TaskCard task={task} provided={provided} meetingId="" />;
                              }}
                            </Draggable>
                          ),
                      )}
                      {!doneIds.length && <div style={{ height: '20px' }}></div>}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
